// Module
var code = `<div class="jumbotron-surface scene-edit-surface">

  <div class="jumbotron-panel-head">
    <span class="jumbotron-heading" ng-if="!\$ctrl.edit">New Scene</span>
    <span class="jumbotron-heading" ng-if="\$ctrl.edit">Edit Scene</span>

    <div class="scene-edit-actions">
      <back-button default-state="manager.settings" class="btn btn-sm btn-outline-secondary"></back-button>
    </div>
  </div>

  <form name="\$ctrl.clientForm" class="scene-edit-body" ng-submit="\$ctrl.submit(\$ctrl.clientForm.\$valid)">

    <div class="row g-3">
      <div class="col-12">
        <label for="name" class="jumbotron-field-label form-label">Name</label>
        <input id="name" type="text" class="form-control form-control-sm" ng-model="\$ctrl.scene.name"
          placeholder="Give the Scene a name" required="required" minlength="1" />
      </div>

      <div class="col-12 col-sm-8">
        <label class="jumbotron-field-label form-label">Orientation</label>
        <div id="orientation" role="group" aria-label="Orientation" class="btn-group scene-edit-orientation">
          <button type="button" class="btn btn-sm btn-outline-primary"
            ng-class="{'active': \$ctrl.scene.orientation === 'l'}" ng-click="\$ctrl.scene.orientation = 'l'">
            <i class="fas fa-arrows-left-right" aria-hidden="true"></i>
            <span> Landscape</span>
          </button>
          <button type="button" class="btn btn-sm btn-outline-primary"
            ng-class="{'active': \$ctrl.scene.orientation === 'p'}" ng-click="\$ctrl.scene.orientation = 'p'">
            <i class="fas fa-arrows-up-down" aria-hidden="true"></i>
            <span> Portrait</span>
          </button>
        </div>
      </div>

      <div class="col-12 col-sm-4">
        <label for="color" class="jumbotron-field-label form-label">Color</label>
        <input id="color" type="color" class="form-control form-control-color form-control-sm"
          ng-model="\$ctrl.scene.color" list="colorList" />
        <datalist id="colorList">
          <option ng-repeat="color in \$ctrl.colors" value="{{color}}"></option>
        </datalist>
      </div>

      <div class="col-12">
        <label for="clientId" class="jumbotron-field-label form-label">Browser id</label>
        <input id="clientId" name="clientId" type="text" class="form-control form-control-sm"
          ng-model="\$ctrl.scene.clientId" ng-change="\$ctrl.validateClientIdInput()"
          ng-class="{'is-invalid': \$ctrl.clientForm.clientId.\$invalid}"
          placeholder="The client id of the master of this Scene" />
        <div class="invalid-feedback" ng-if="\$ctrl.clientForm.clientId.\$invalid && \$ctrl.clientForm.clientId.\$dirty">
          Please enter a valid UUID or leave empty
        </div>
        <p class="jumbotron-note scene-edit-note">The Configure Scenes page shows the id of a browser.</p>
      </div>
    </div>

    <div class="scene-edit-footer">
      <button type="button" class="btn btn-sm btn-discreet-danger scene-edit-remove" ng-if="\$ctrl.edit"
        ng-click="\$ctrl.remove()" ng-disabled="\$ctrl.sceneContent.length">
        <i class="far fa-trash-can" aria-hidden="true"></i>
        <span>Delete</span>
      </button>
      <button type="submit" class="btn btn-sm btn-primary" ng-disabled="\$ctrl.isSaveDisabled()">
        <span ng-if="!\$ctrl.edit">Add</span>
        <span ng-if="\$ctrl.edit">Save</span>
      </button>
    </div>
  </form>
</div>
`;
// Exports
export default code;